/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreditLedgerEntryResponse {
  id: string;
  amount: number;
  balance_after: number;
  entry_type: string;
  reason: string;
  reference_type: string | null;
  reference_id: string | null;
  actor_user_id: string | null;
  created_at: string;
  category?: string;
  category_label?: string | null;
  actor_name?: string | null;
  actor_email?: string | null;
}
